import Model, { attr } from '@ember-data/model';

export default class UserSetting extends Model {
  @attr('number') searchKeywordUrlId;
  @attr('number') dynamicViewId;
  @attr('number') backlinkViewId;
  @attr('number') siteAuditViewId;
  @attr() settingsData;
}
